import React, { Component } from 'react';
import { MenuItem, Tooltip } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Select from 'react-select';

class Option extends Component {
    handleClick = event => {
        this.props.selectOption(this.props.data, event);
    };

    render() {
        const { children, isFocused, isSelected, onFocus, options } = this.props;
        let title = '';
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === this.props.value) {
                title = options[i].title;
                break;
            }
        }

        let item = title === undefined ?    <div style={{ width: '100%', lineHeight: '46px', paddingRight: '16px',textAlign: 'right'  }}>
                                                {children}
                                            </div>
                                        :
                                            // <div className='divList'>
                                                <Tooltip title={title} enterDelay={500} style={{ width: '90%', zIndex: 10000 }}>
                                                    <div style={{ lineHeight: '46px', paddingRight: '16px', textAlign: 'right', zIndex: 10000 }}>
                                                        {children}
                                                    </div>
                                                </Tooltip>

        return (
            <MenuItem
                onFocus={onFocus}
                selected={isFocused}
                onClick={this.handleClick}
                component="div"
                style={{
                    fontWeight: isSelected ? 500 : 400,
                    padding: '0px',
                    minHeight: '46px'
                }}
            >
                {item}
            </MenuItem>
        );
    }
}

function SelectWrapped(props) {
    const { classes, ...other } = props;

    let SelectCompo = {
        Option: Option,
        DropdownIndicator: ArrowDropDownIcon
    }
    if (props.extraComp !== undefined) {
        SelectCompo[props.extraComp.name] = props.extraComp.comp;
    }

    return (
        <Select
            menuPortalTarget={document.getElementsByClassName("React__Select__Container")[0]}
            components={SelectCompo}
            styles={customStyles}
            isMulti={props.isMulti}
            closeMenuOnSelect={props.closeMenuOnSelect}
            isClearable={props.isClearable}
            disabled={props.isDisabled}
            {...other}
        />
    );
}

const customStyles = {
    control: () => ({
        display: "flex",
        alignItems: "center",
        border: 0,
        height: "auto",
        background: "transparent",
        "&:hover": {
            boxShadow: "none"
        }
    }),
    menu: () => ({
        backgroundColor: "white",
        boxShadow: "1px 2px 6px #888888", // should be changed as material-ui
        position: "relative",
        left: 0,
        top: `calc(100% + 1px)`,
        width: "100%",
        zIndex: 2,
        maxHeight: 48 * 4.5
    }),
    menuList: () => ({
        maxHeight: 48 * 4.5,
        overflowY: "auto"
    }),
    menuPortal: base => ({ 
        ...base, 
        position: "absolute",
        zIndex: 1301 
    })

};


export default SelectWrapped;